/**
 * 地形タイプ名
 */
export const MAP_TYPE_CAVES = '自然'
export const MAP_TYPE_RUINS = '遺跡'
export const MAP_TYPE_ICE = '氷'
export const MAP_TYPE_WATER = '水'
export const MAP_TYPE_FIRE = '火山'

/**
 * 地形タイプとその確率
 */
export const MAP_TYPE_PROBABILITIES = [
  { probability: 30, name: MAP_TYPE_CAVES },
  { probability: 40, name: MAP_TYPE_RUINS },
  { probability: 10, name: MAP_TYPE_ICE },
  { probability: 10, name: MAP_TYPE_WATER },
  { probability: 10, name: MAP_TYPE_FIRE }
]

/**
 * 地図ランクと深さの関係
 */
export const MAP_FLOOR_COUNT_RANGES = [
  { minInput: 2, maxInput: 55, minOutput: 2, maxOutput: 4 },
  { minInput: 56, maxInput: 75, minOutput: 4, maxOutput: 6 },
  { minInput: 76, maxInput: 100, minOutput: 6, maxOutput: 10 },
  { minInput: 101, maxInput: 120, minOutput: 8, maxOutput: 12 },
  { minInput: 121, maxInput: 140, minOutput: 10, maxOutput: 14 },
  { minInput: 141, maxInput: 180, minOutput: 10, maxOutput: 16 },
  { minInput: 181, maxInput: 200, minOutput: 11, maxOutput: 16 },
  { minInput: 201, maxInput: 220, minOutput: 12, maxOutput: 16 },
  { minInput: 221, maxInput: 248, minOutput: 14, maxOutput: 16 }
]

/**
 * 地図ランクとB1F敵ランクの関係
 */
export const MAP_B1F_ENEMY_RANK_RANGES = [
  { minInput: 2, maxInput: 55, minOutput: 1, maxOutput: 3 },
  { minInput: 56, maxInput: 75, minOutput: 2, maxOutput: 4 },
  { minInput: 76, maxInput: 100, minOutput: 3, maxOutput: 5 },
  { minInput: 101, maxInput: 140, minOutput: 4, maxOutput: 6 },
  { minInput: 141, maxInput: 180, minOutput: 5, maxOutput: 7 },
  { minInput: 181, maxInput: 200, minOutput: 6, maxOutput: 9 },
  { minInput: 201, maxInput: 220, minOutput: 8, maxOutput: 9 },
  { minInput: 221, maxInput: 248, minOutput: 9, maxOutput: 9 }
]

/**
 * ボス名
 */
export const MAP_BOSS_EQUINOX = '黒竜丸'
export const MAP_BOSS_NEMEAN = 'ハヌマーン'
export const MAP_BOSS_SHOGUM = 'スライムジェネラル'
export const MAP_BOSS_TRAUMINATOR = 'Sキラーマシン'
export const MAP_BOSS_ELUSID = 'イデアラゴン'
export const MAP_BOSS_SIR_SANGUINUS = 'ブラッドナイト'
export const MAP_BOSS_ATLAS = 'アトラス'
export const MAP_BOSS_HAMMIBAL = '怪力軍曹イボイノス'
export const MAP_BOSS_FOWLEYE = '邪眼皇帝アウルート'
export const MAP_BOSS_EXCALIPURR = '魔剣神レパルド'
export const MAP_BOSS_TYRANNOSAURUS_WRECKS = '破壊神フォロボス'
export const MAP_BOSS_GREYGNARL = 'グレイナル'

/**
 * ボスとその確率比
 */
export const MAP_BOSS_PROBABILITIES = [
  { probability: 100, name: MAP_BOSS_EQUINOX },
  { probability: 100, name: MAP_BOSS_NEMEAN },
  { probability: 75, name: MAP_BOSS_SHOGUM },
  { probability: 75, name: MAP_BOSS_TRAUMINATOR },
  { probability: 50, name: MAP_BOSS_ELUSID },
  { probability: 50, name: MAP_BOSS_SIR_SANGUINUS },
  { probability: 30, name: MAP_BOSS_ATLAS },
  { probability: 20, name: MAP_BOSS_HAMMIBAL },
  { probability: 20, name: MAP_BOSS_FOWLEYE },
  { probability: 20, name: MAP_BOSS_EXCALIPURR },
  { probability: 10, name: MAP_BOSS_TYRANNOSAURUS_WRECKS },
  { probability: 10, name: MAP_BOSS_GREYGNARL }
]

/**
 * 地図ランクとボスの関係
 */
export const MAP_BOSS_RANGES = [
  { minInput: 2, maxInput: 60, minOutput: 0, maxOutput: 2 },
  { minInput: 61, maxInput: 80, minOutput: 1, maxOutput: 4 },
  { minInput: 81, maxInput: 100, minOutput: 2, maxOutput: 6 },
  { minInput: 101, maxInput: 120, minOutput: 3, maxOutput: 6 },
  { minInput: 121, maxInput: 140, minOutput: 4, maxOutput: 8 },
  { minInput: 141, maxInput: 160, minOutput: 5, maxOutput: 8 },
  { minInput: 161, maxInput: 180, minOutput: 6, maxOutput: 9 },
  { minInput: 181, maxInput: 200, minOutput: 7, maxOutput: 11 },
  { minInput: 201, maxInput: 248, minOutput: 0, maxOutput: 11 }
]

/**
 * 地図名1
 */
export const MAP_NAME1_CLAY = 'はかなき'
export const MAP_NAME1_ROCK = 'ちいさな'
export const MAP_NAME1_GRANITE = 'うす暗き'
export const MAP_NAME1_BASALT = 'ゆらめく'
export const MAP_NAME1_GRAPHITE = 'ざわめく'
export const MAP_NAME1_IRON = 'ねむれる'
export const MAP_NAME1_COPPER = '怒れる'
export const MAP_NAME1_BRONZE = '呪われし'
export const MAP_NAME1_STEEL = '放たれし'
export const MAP_NAME1_SILVER = 'けだかき'
export const MAP_NAME1_GOLD = 'わななく'
export const MAP_NAME1_PLATINUM = '残された'
export const MAP_NAME1_RUBY = '見えざる'
export const MAP_NAME1_EMERALD = 'あらぶる'
export const MAP_NAME1_SAPPHIRE = 'とどろく'
export const MAP_NAME1_DIAMONDO = '大いなる'

export const MAP_NAME1_LIST = [
  MAP_NAME1_CLAY,
  MAP_NAME1_ROCK,
  MAP_NAME1_GRANITE,
  MAP_NAME1_BASALT,
  MAP_NAME1_GRAPHITE,
  MAP_NAME1_IRON,
  MAP_NAME1_COPPER,
  MAP_NAME1_BRONZE,
  MAP_NAME1_STEEL,
  MAP_NAME1_SILVER,
  MAP_NAME1_GOLD,
  MAP_NAME1_PLATINUM,
  MAP_NAME1_RUBY,
  MAP_NAME1_EMERALD,
  MAP_NAME1_SAPPHIRE,
  MAP_NAME1_DIAMONDO
]

/**
 * B1F敵ランクと地図名1の関係
 */
export const MAP_NAME1_RANGES = [
  { minInput: 1, maxInput: 2, minOutput: 0, maxOutput: 4 },
  { minInput: 3, maxInput: 4, minOutput: 3, maxOutput: 7 },
  { minInput: 5, maxInput: 6, minOutput: 6, maxOutput: 11 },
  { minInput: 7, maxInput: 8, minOutput: 6, maxOutput: 15 },
  { minInput: 9, maxInput: 9, minOutput: 11, maxOutput: 15 }
]

/**
 * 地図名2
 */
export const MAP_NAME2_JOY = '花の'
export const MAP_NAME2_BLISS = '岩の'
export const MAP_NAME2_GLEE = '風の'
export const MAP_NAME2_DOUBT = '空の'
export const MAP_NAME2_WOE = '獣の'
export const MAP_NAME2_DOLOUR = '夢の'
export const MAP_NAME2_REGRET = '影の'
export const MAP_NAME2_BANE = '大地の'
export const MAP_NAME2_FEAR = '運命の'
export const MAP_NAME2_DREAD = '魂の'
export const MAP_NAME2_HURT = '闇の'
export const MAP_NAME2_GLOOM = '光の'
export const MAP_NAME2_DOOM = '魔神の'
export const MAP_NAME2_EVIL = '星々の'
export const MAP_NAME2_RUIN = '悪霊の'
export const MAP_NAME2_DEATH = '神々の'

export const MAP_NAME2_LIST = [
  MAP_NAME2_JOY,
  MAP_NAME2_BLISS,
  MAP_NAME2_GLEE,
  MAP_NAME2_DOUBT,
  MAP_NAME2_WOE,
  MAP_NAME2_DOLOUR,
  MAP_NAME2_REGRET,
  MAP_NAME2_BANE,
  MAP_NAME2_FEAR,
  MAP_NAME2_DREAD,
  MAP_NAME2_HURT,
  MAP_NAME2_GLOOM,
  MAP_NAME2_DOOM,
  MAP_NAME2_EVIL,
  MAP_NAME2_RUIN,
  MAP_NAME2_DEATH
]

/**
 * ボスと地図名2の関係
 */
export const MAP_NAME2_RANGES = [
  { minInput: 0, maxInput: 2, minOutput: 0, maxOutput: 5 },
  { minInput: 3, maxInput: 5, minOutput: 3, maxOutput: 8 },
  { minInput: 6, maxInput: 8, minOutput: 6, maxOutput: 11 },
  { minInput: 9, maxInput: 11, minOutput: 9, maxOutput: 15 }
]

/**
 * 地図名3
 */
export const MAP_NAME3_CAVE = '洞くつ'
export const MAP_NAME3_MINE = '坑道'
export const MAP_NAME3_LAIR = 'アジト'
export const MAP_NAME3_PATH = '道'
export const MAP_NAME3_CRYPT = '墓場'
export const MAP_NAME3_NEST = '巣'
export const MAP_NAME3_WORLD = '世界'
export const MAP_NAME3_ABYSS = '奈落'
export const MAP_NAME3_TUNNEL = '地下道'
export const MAP_NAME3_RUINS = '遺跡'
export const MAP_NAME3_MAZE = '迷宮'
export const MAP_NAME3_CREVASSE = '雪道'
export const MAP_NAME3_ICEPIT = '氷穴'
export const MAP_NAME3_SNOWHALL = '雪原'
export const MAP_NAME3_TUNDRA = '凍土'
export const MAP_NAME3_GLACIER = '氷河'
export const MAP_NAME3_MARSH = '沼地'
export const MAP_NAME3_LAKE = '地底湖'
export const MAP_NAME3_MOOR = '湿原'
export const MAP_NAME3_WATERWAY = '水脈'
export const MAP_NAME3_CHASM = '眠る地'
export const MAP_NAME3_CRATER = '火口'
export const MAP_NAME3_DUNGEON = '牢ごく'
export const MAP_NAME3_VOID = 'じごく'

export const MAP_NAME3_LIST = [
  MAP_NAME3_CAVE,
  MAP_NAME3_MINE,
  MAP_NAME3_LAIR,
  MAP_NAME3_PATH,
  MAP_NAME3_CRYPT,
  MAP_NAME3_NEST,
  MAP_NAME3_WORLD,
  MAP_NAME3_ABYSS,
  MAP_NAME3_TUNNEL,
  MAP_NAME3_RUINS,
  MAP_NAME3_MAZE,
  MAP_NAME3_CREVASSE,
  MAP_NAME3_ICEPIT,
  MAP_NAME3_SNOWHALL,
  MAP_NAME3_TUNDRA,
  MAP_NAME3_GLACIER,
  MAP_NAME3_MARSH,
  MAP_NAME3_LAKE,
  MAP_NAME3_MOOR,
  MAP_NAME3_WATERWAY,
  MAP_NAME3_CHASM,
  MAP_NAME3_CRATER,
  MAP_NAME3_DUNGEON,
  MAP_NAME3_VOID
]

/**
 * 地図名3の候補をタイプ別に分類
 */
export const MAP_NAME3_INDEX_BY_TYPE = [
  [0, 1, 2, 3, 4, 5, 6, 7],
  [8, 1, 2, 3, 4, 9, 6, 10],
  [0, 11, 12, 13, 4, 14, 6, 15],
  [0, 16, 17, 18, 4, 19, 6, 20],
  [0, 1, 21, 22, 4, 5, 6, 23]
]

/**
 * 深さと地図名3の関係
 */
export const MAP_NAME3_RANGES = [
  { minInput: 2, maxInput: 3, minOutput: 0, maxOutput: 1 },
  { minInput: 4, maxInput: 5, minOutput: 0, maxOutput: 2 },
  { minInput: 6, maxInput: 7, minOutput: 0, maxOutput: 3 },
  { minInput: 8, maxInput: 9, minOutput: 1, maxOutput: 4 },
  { minInput: 10, maxInput: 11, minOutput: 1, maxOutput: 5 },
  { minInput: 12, maxInput: 13, minOutput: 2, maxOutput: 6 },
  { minInput: 14, maxInput: 15, minOutput: 3, maxOutput: 7 },
  { minInput: 16, maxInput: 16, minOutput: 5, maxOutput: 7 }
]
